<template>
  <div>
      <b-card :title="titlepage">
        <b-overlay :show="isBusy && isEdit" rounded="sm" no-wrap />
        <validation-observer ref="simpleRules">
        <b-container>
            <b-row class="mb-3">
                <b-col sm="4">
                    <validation-provider
                    #default="{ errors }"
                    name="Product"
                    rules="required"
                    >
                    <b-form-group
                        label-for="input-product"
                    >
                        <template #label>
                            Product <span class="text-danger">*</span>
                        </template>
                        <b-form-input

                            id="input-product"
                            placeholder="Product"
                            v-model="product"
                        />
                        <small class="text-danger" v-for="(data, index) in errors" :key="index">{{ data }}</small>
                    </b-form-group>
                    </validation-provider>
                </b-col>
                <b-col sm="4">
                    <validation-provider
                    #default="{ errors }"
                    name="Portfolio"
                    rules="required"
                    >
                        <b-form-group>
                            Portfolio <span class="text-danger">*</span>
                            <v-select
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            label="name"
                            :options="productCategories"
                            v-model="prodCategory"
                            />
                        </b-form-group>
                        <small class="text-danger" v-for="(data, index) in errors" :key="index">{{ data }}</small>
                    </validation-provider>
                </b-col>
								<b-col sm="4">
									<validation-provider #default="{ errors }" name="Category" rules="required">
										<b-form-group>
											Category <span class="text-danger">*</span>
											<v-select
												:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
												:options="subCategories"
												label="name"
												v-model="prodSubCategory"
												:reduce="item => item"
												:disabled="isLoadingSubCat || (subCategories.length === 0 && !prodSubCategory)"
											/>
										</b-form-group>
										<small class="text-danger" v-for="(data, index) in errors" :key="index">{{ data }}</small>
									</validation-provider>
								</b-col>
            </b-row>
        </b-container>
        <form-wizard :options="options" :content.sync="content" :methods="methods" :dropzoneElements="dropzoneElements" :product-kode="$route.params.key" ref="formWizard"/>
        </validation-observer>
        <div class="mb-2"></div>
        <b-row class="justify-content-end pr-2 mt-2" >
                <b-overlay
                    :show="form_loading"
                    rounded="sm"
                >
                    <b-button
                        variant="primary"
                        @click="save()"
                    >
                        Save
                    </b-button>
                </b-overlay>
                <b-button 
                    v-if="isEdit && canApprove"
                    class="ml-1"
                    variant="outline-success"
                    @click="approval()"
                >
                    Approve
                </b-button>
                <b-button 
                    class="ml-1"
                    variant="outline-secondary"
                    @click="$router.back()"
                >
                    Cancel
                </b-button>
        </b-row>
      </b-card>
  </div>
</template>

<script>
import { BLink, BImg, BContainer, BRow, BCol, BCard, BFormGroup, BFormInput, BButton, BProgress, BCardText, BDropdown, BDropdownItem, BOverlay } from 'bootstrap-vue'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import vSelect from 'vue-select'

import dummyData from './dummyFirst'
import formwizardVue from './formwizard.vue'
import { generateToken } from '@/auth/helperAuth'


export default {
    components: {
        BLink,
        BImg,
        BCol,
        BContainer,
        BRow,
        BCard,
        BProgress,
        BCardText,
        BDropdown,
        BDropdownItem,
        BButton,
        BFormGroup,
        BFormInput,
        BOverlay,
        quillEditor,
        vSelect,
        'form-wizard': formwizardVue
    },
    data() {
        return {
            token:"",
            isBusy: true,
            dropzone: null,
            title_product: '',
            author: '',
            date: '',
            description: '',
            title: 'Product',
            form_loading: false,
            productCategories: [],
            product: '',
            prodCategory: '',
            show_status: 0,
            freshContent: {},
            content: {
                description: '',
                shortDescription: '',
                benefit: '',
                valueProposition: '',
                salesProposition: '',
                customerSTP: '',
                spesificationFeatures: '',
                configuration: '',
                tarif_description: '',
                case_study_description: '',
                slgsla: '',
                faq: '',
                cfu: '',
                cfu_business_line: '',
                cfu_product_line: '',
                parent: '',
                child: '',
                division: '',
                banner_web: '',
                banner_mobile: '',
                tarif_file: '',
                case_study: '',
                product_sharing: '',
                file_referensi: '',
                photo_product: '',
                proposal_product: '',
                map_banner_web: [],
                map_banner_mobile: [],
                map_tarif_file: [],
                map_product_sharing: [],
                map_file_referensi: [],
                map_photo_product: [],
                map_proposal_product: [],
                map_case_study: [],
                existing_banner_web: [],
                existing_banner_mobile: [],
                existing_photo_product: [],
                existing_tarif_file: [],
                existing_case_study: [],
                existing_product_sharing: [],
                existing_file_referensi: [],
                existing_proposal_product: [],
                relatedProduct: [],
                contacts: [],
                faqs: [],
                timePortfolio: '',
                partner: '',
                stpType:[]
            },
            options: {
                divisions: [],
                timePortfolios: [],
                cfus: [],
                cfusBusiness: [],
                cfusProduct: [],
                productList: [],
                partnerList: [],
                stpType: ["Segmen", "Target"],
                contactType: ['product_information', 'commercial']
            },
            methods: {
            },
            dropzoneElements: {
                banner_web: null,
                banner_mobile: null,
                photo_product: null,
                tarif_file: null,
                case_study: null,
                product_sharing: null,
                file_referensi: null,
                proposal_product: null,
            },
						subCategoriesRaw: [],
						prodSubCategory: '',
						isLoadingSubCat: false,
        }
    },
    computed: {
        isEdit() {
            return typeof this.$route.params.key == 'undefined' ? false : true
        },
        titlepage() {
            return this.isEdit === false ? `Add ${this.title}` : `Edit ${this.title}`
        },
        canApprove() {
            // return this.show_status == 0 ? true : false
            return this.isApprover
        },
        isApprover() {
            let permissions = this.$store.getters['oauth/getActiveUser'].permissions
            if (!permissions.includes('approve_product')) {
                return false
            }
            return true
        },
				subCategories() {
					return (this.subCategoriesRaw || []).map(sc => ({
						...sc,
						id: sc?.ID ?? sc?.id,
						name: sc?.NAME ?? sc?.name,
					}))
				},
    },
    created() {
        const payload = {
            client: "product-catalog-fe",
            kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
            user: this.$store.getters['oauth/getActiveUser'].name,
            role: this.$store.getters['oauth/getActiveUser'].role,
        };
        this.token = generateToken(payload)
        this.methods = {
            onCfuChange: this.onCfuChange,
            onCfuBusinessChange: this.onCfuBusinessChange
        }
        this.freshContent = {...this.content}
    },
		mounted() {
			(async () => {
				try {
					this.isBusy = true
					await Promise.all([
						this.getProductCategory().catch(e => console.error('[Cat Error]', e)),
						this.getTimePorfolio().catch(e => console.error('[Time Error]', e)),
						this.getCFU().catch(e => console.error('[CFU Error]', e)),
						this.getProductDropdown().catch(e => console.error('[Dropdown Error]', e)),
						this.getPartner().catch(e => console.error('[Partner Error]', e)),
					])
					await this.fetchSubCategories().catch(e => console.error('[SubCat Error]', e))
					console.log('[Mounted] SubCategories loaded:', this.subCategories?.length || 0)

					if (!this.isEdit) {
						this.isBusy = false
						return
					}
					const dataProduct = await this.getProduct()
					console.log('[Edit Mode] Product loaded:', dataProduct)

					if (!dataProduct) {
						console.error('[Edit Mode] No product data returned')
						return
					}

					await this.$nextTick()
					if (this.$refs.formWizard && typeof this.$refs.formWizard.updateEditor === 'function') {
						this.$refs.formWizard.updateEditor()
					}

					const cfuIds = (dataProduct.cfu_business_details || []).map(e => e.cfu_id).join(',')
					if (cfuIds) {
						const res = await this.getCFUBusinessLine(cfuIds).catch(e => console.error(e))
						const records = res?.data?.data?.records || []
						this.content.cfu_business_line = records.filter(item =>
							dataProduct.cfu_business_details.some(
								detail => detail.cfu_business_line_id === item.id
							)
						)
					}
					const cfuProdIds = (dataProduct.cfu_product_details || []).map(e => e.cfu_business_line_id).join(',')
					if (cfuProdIds) {
						const res2 = await this.getCFUProductLine(cfuProdIds).catch(e => console.error(e))
						const records2 = res2?.data?.data?.records || []
						this.content.cfu_product_line = records2.filter(item =>
							dataProduct.cfu_product_details.some(
								detail => detail.cfu_product_line_id === item.id
							)
						)
					}
					const divIds = (dataProduct.division_details || []).map(e => e.cfu_id).join(',')
					if (divIds) {
						const res3 = await this.getDivision(divIds).catch(e => console.error(e))
						const records3 = res3?.data?.data?.records || []
						this.content.division = records3.filter(item =>
							dataProduct.division_details.some(
								detail => detail.division_id === item.id
							)
						)
					}
					this.prefillSubCategory(dataProduct)

				} catch (err) {
					console.error('[Mounted Error]', err)
				} finally {
					this.isBusy = false
				}
			})()
		},
    methods: {
        clickInputFile() {
            $("#dropzoneel").trigger('click')
        },
        async getProduct() {
            console.log('[getProduct] Fetching product:', this.$route.params.key)
            return await this.$http.get(`/product/id/${this.$route.params.key}/set/first`)
            .then( res => {
                console.log('[getProduct] Response:', res.data)
                let data = res.data?.data?.records || res.data?.records || res.data
                if (!data) return null

                this.product = data.PRODUCT || ''
                this.content.description = data.PROD_DESCRIPTION || ''
                this.content.shortDescription = data.SHORT_DESCRIPTION || ''
                this.content.customerSTP = data.PROD_CUST_STP || ''
                this.content.tarif_description = data.PROD_TARIFF || ''
                this.content.case_study_description = data.PROD_CASE_STUDY || ''
                this.content.slgsla = data.PROD_SLA_SLG || ''
                this.content.faq = data.FAQ || ''
                this.content.configuration = data.PROD_CONFIG || ''
                this.content.spesificationFeatures = data.PROD_FEATURES || ''
                this.content.valueProposition = data.VALUE_PROPOSITION || ''
                this.content.salesProposition = data.SALES_PROPOSITION || ''
                this.content.benefit = data.PROD_BENEFIT || ''
                this.content.contacts = data.contacts || []
                this.content.faqs = data.faqs || []
                this.show_status = data.PROD_SHOW_STATUS || 0
                this.prodCategory = (this.productCategories || []).find(item => item.id == data.PROD_CATEGORY) || ''
                this.content.cfu = (this.options.cfus || []).filter(item => {
                    let cfu = (data.cfu_details || []).filter(detail => detail.cfu_id == item.id)
                    return cfu.length > 0
                })
                this.content.division = (this.options.divisions || []).find(item => item.KODE == data.DIVISION) || ''
                this.content.parent = (this.options.productList || []).find(item => item.KODE == data.INHERIT_FROM) || ''
                this.content.child = (this.options.productList || []).find(item => item.KODE == data.CHILD_ID) || ''
                this.content.timePortfolio = (this.options.timePortfolios || []).find(item => item.id == data.TIME_PORTFOLIO_ID) || ''
                this.content.partner = (this.options.partnerList || []).find(item => item.PROD_OWNER_ID == data.PARTNER_ID) || ''

                if (Array.isArray(data.bannersLink)) {
                    this.content.existing_banner_web = data.bannersLink
                }
                if (Array.isArray(data.bannerMobileLink)) {
                    this.content.existing_banner_mobile = data.bannerMobileLink
                }
                const photoProductLink = data.photoProductLink || data.productPhotoLink || data.photo_product || [];
                if (Array.isArray(photoProductLink)) {
                    this.content.existing_photo_product = photoProductLink
                }
                if (Array.isArray(data.tarifFileLink)) {
                    this.content.existing_tarif_file = data.tarifFileLink
                }
                if (Array.isArray(data.caseStudyFileLink)) {
                    this.content.existing_case_study = data.caseStudyFileLink
                }
                if (Array.isArray(data.videoLink)) {
                    this.content.existing_product_sharing = data.videoLink
                }
                if (Array.isArray(data.referensi_product)) {
                    this.content.existing_file_referensi = data.referensi_product
                }
                const proposalProductLink = data.proposalProductLink || data.productProposalLink || data.proposal_product || [];
                if (Array.isArray(proposalProductLink)) {
                    this.content.existing_proposal_product = proposalProductLink
                }
                if (data.related_product == null) {
                    this.content.relatedProduct = []
                } else {
                    this.content.relatedProduct = data.related_product
                }
                return data
            })
            .catch(err => {
                console.error('[getProduct Error]', err)
                return null
            })
        },
        async prefillSubCategory(dataProduct) {
            const scd = Array.isArray(dataProduct.subcategory_tags_details)
                ? dataProduct.subcategory_tags_details
                : [];

            if (scd.length > 0) {
                const chosen = scd[0];
                const chosenId = chosen?.sub_category_tags_id ?? chosen?.id ?? chosen?.ID;
                const match = this.subCategories.find(o => (o.id ?? o.ID) === chosenId);
                this.prodSubCategory = match || { id: chosenId, name: chosen.name ?? chosen.NAME ?? 'Unknown' };
                console.log('[PrefillSubCat] From subcategory_tags_details:', this.prodSubCategory);
                return;
            }

            const subCatIdFromField = dataProduct.SUB_CATEGORY_TAGS;

            if (subCatIdFromField) {
                const match = this.subCategories.find(o => (o.id ?? o.ID) == subCatIdFromField);
                this.prodSubCategory = match || { id: subCatIdFromField, name: 'Unknown Sub Category' };
                console.log('[PrefillSubCat] From SUB_CATEGORY_TAGS field:', subCatIdFromField, '→', this.prodSubCategory);
                return;
            }
            this.prodSubCategory = null;
        },
        // async getStpTypeProduct() {
        //     this.$http.get(
        //         `${process.env.VUE_APP_API_HELPER_URL}/product/list?kode=${this.$route.params.key}&page=1&perPage=1`,
        //         {
        //         withCredentials: true,
        //         headers: {
        //             'Client-Device': 'browser',
        //             'Authorization': `${this.token}`,
        //         },
        //         }
        //     ).then(({ data }) => {
        //         const productList = data.data || [];

        //         productList.forEach(item => {
        //         if (item.stp && Array.isArray(item.stp)) {
        //             const stpTypes = item.stp.map(stpItem => stpItem.type);
        //             this.content.stpType.push(...stpTypes);
        //         }
        //         });
        //     });
        // }, 
        async getProductCategory() {
            return await this.$http.get(`/product-category/take/all`)
            .then( res => {
                this.productCategories = res.data.data.records
            })
            .catch( err => {
                console.error(err)
            })
        },
        dummyHttpGetProductFirst() {
            return new Promise(function(resolve,reject) {
            let res = {
                data: dummyData
            }
            resolve(res)
            })
        },
        async fetchSubCategories() {
            this.isLoadingSubCat = true
            try {
                const res = await this.$http.get(
                    `${process.env.VUE_APP_API_HELPER_URL}/internal/data/list`,
                    {
                        params: { table: 'SUB_CATEGORY_TAGS', page: 0, perPage: 0 },
                        headers: { accept: 'application/json', Authorization: this.token },
                        withCredentials: true,
                    }
                )
                const payload = res?.data
                this.subCategoriesRaw = payload?.data || payload?.records || []
                console.log('[SubCat] Loaded:', this.subCategories.length, 'items', this.subCategories)
            } catch (e) {
                console.error('[SubCat] Load error:', e)
                this.subCategoriesRaw = []
            } finally {
                this.isLoadingSubCat = false
            }
        },

        // async createProduct() {
        //     let fd = this.getFormData();
        //     // return
        //     // files[0] && fd.append('image', files[0])
        //     let conf = {
        //         ...this.$store.getters['app/axiosConf'],
        //         url: '/product',
        //         data: fd
        //     }
        //     this.form_loading = true
        //     return await this.$http(conf)
        //     .then(res => {
        //         console.log(res)
        //         // this.$notif('Success', 'Product has been successfully created.', 'success')
        //         // this.$router.back()
        //         // this.resetFields()
        //     })
        //     .catch(err => {
        //         let message = ''
        //         if (typeof err.data.errors === 'object') {
        //             message = err.data.errors[Object.keys(err.data.errors)[0]][0]
        //         } else if (typeof err.data.exception === 'object') {
        //             message = err.data.exception.message
        //         }
        //         this.$notif('Something Error', message , 'danger')
        //     })
        //     .finally(() => this.form_loading = false)
        // },
        async createProduct() {
          let fd = this.getFormData();
          let conf = {
              ...this.$store.getters['app/axiosConf'],
              url: '/product',
              method: 'POST',
              data: fd,
          };

          this.form_loading = true;
          try {
            const res = await this.$http(conf);
            if(res.status === 200) {
            //   const upsertPayload = {
            //     product_kode: res.data?.data?.KODE,
            //     category: this.content.stpType
            //   }
            //   const response = await this.$http.put(
            //     `${process.env.VUE_APP_API_HELPER_URL}/product/stp`,
            //     upsertPayload
            //   )
              this.$notif('Success', 'Product has been successfully created.', 'success')
              this.$router.back()
              this.resetFields()
            }else{
              this.$notif('Failed, to create product. try again later', {
                title: 'Error',
                variant: 'danger',
                solid: true
              })
            }
          } catch (err) {
              let message = '';
              if (typeof err.data?.errors === 'object') {
              message = err.data.errors[Object.keys(err.data.errors)[0]][0];
              } else if (typeof err.data?.exception === 'object') {
              message = err.data.exception.message;
              } else {
              message = err.message || 'Unexpected error occurred.';
              }
              this.$notif('Something Error', message, 'danger');
          } finally {
              this.form_loading = false;
          }
        },
        async updateProduct() {
            let fd = this.getFormData();
            let conf = {
                ...this.$store.getters['app/axiosConf'],
                url: '/product/' + this.$route.params.key,
                method: 'POST',
                data: fd,
            }

            this.form_loading = true;

            try {
                const res = await this.$http(conf);
                if (res.status === 200) {
                // const upsertPayload = {
                //     product_kode: res.data?.data?.KODE,
                //     category: this.content.stpType
                // }

                // await this.$http.put(
                //     `${process.env.VUE_APP_API_HELPER_URL}/product/stp`,
                //     upsertPayload
                // );

                    this.$notif('Success', 'Product has been successfully updated.', 'success');
                    this.$router.back();
                    this.resetFields();
                } else {
                    this.$notif('Failed to update product. Try again later.', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                }
            } catch (err) {
                let message = '';
                if (typeof err.data?.errors === 'object') {
                message = err.data.errors[Object.keys(err.data.errors)[0]][0];
                } else if (typeof err.data?.exception === 'object') {
                message = err.data.exception.message;
                } else {
                message = err.message || 'Unexpected error occurred.';
                }

                this.$notif('Something Error', message, 'danger');
            } finally {
                this.form_loading = false;
            }
        },

        getFormData() {
          this.$refs.formWizard.syncMedia()
          let banner_web = this.mappingFile(this.content.banner_web, this.content.map_banner_web)
          let current_banner_web = this.mappingCurrentFile(this.content.existing_banner_web)
          let banner_mobile = this.mappingFile(this.content.banner_mobile, this.content.map_banner_mobile)
          let current_banner_mobile = this.mappingCurrentFile(this.content.existing_banner_mobile)
          let photo_product = this.mappingFile(this.content.photo_product, this.content.map_photo_product)
          let current_photo_product = this.mappingCurrentFile(this.content.existing_photo_product)
          let tarif_file = this.mappingFile(this.content.tarif_file, this.content.map_tarif_file)
          let current_tarif_file = this.mappingCurrentFile(this.content.existing_tarif_file)
          let case_study = this.mappingFile(this.content.case_study, this.content.map_case_study)
          let current_case_study = this.mappingCurrentFile(this.content.existing_case_study)
          let product_sharing = this.mappingFile(this.content.product_sharing, this.content.map_product_sharing)
          let current_product_sharing = this.mappingCurrentFile(this.content.existing_product_sharing)
          let file_referensi = this.mappingFile(this.content.file_referensi, this.content.map_file_referensi)
          let current_file_referensi = this.mappingCurrentFile(this.content.existing_file_referensi)
          let proposal_product = this.mappingFile(this.content.proposal_product, this.content.map_proposal_product)
          let current_proposal_product = this.mappingCurrentFile(this.content.existing_proposal_product)
          let fd = new FormData();
          fd.append('PRODUCT', this.product)
          fd.append('PROD_CATEGORY', this.prodCategory.id)
          fd.append('PROD_DESCRIPTION', this.content.description)
          fd.append('SHORT_DESCRIPTION', this.content.shortDescription)
          fd.append('PROD_CUST_STP', this.content.customerSTP)
          fd.append('PROD_TARIFF', this.content.tarif_description)
          fd.append('PROD_CASE_STUDY', this.content.case_study_description)
          fd.append('PROD_SLA_SLG', this.content.slgsla)
          fd.append('FAQ', this.content.faq)
          fd.append('PROD_CONFIG', this.content.configuration)
          fd.append('PROD_FEATURES', this.content.spesificationFeatures)
          fd.append('VALUE_PROPOSITION', this.content.valueProposition)
          fd.append('SALES_PROPOSITION', this.content.salesProposition)
          fd.append('PROD_BENEFIT', this.content.benefit)
            for (let index = 0; index < banner_web.length; index++) {
              fd.append(`name_banner_web[${index}]`, banner_web[index].name)
              fd.append(`file_banner_web[${index}]`, banner_web[index].file)
            }
            for (let index = 0; index < current_banner_web.length; index++) {
                fd.append(`current_banner_web[${index}]`, JSON.stringify(current_banner_web[index].objItem))
            }
            for (let index = 0; index < banner_mobile.length; index++) {
                fd.append(`name_banner_mobile[${index}]`, banner_mobile[index].name)
                fd.append(`file_banner_mobile[${index}]`, banner_mobile[index].file)
            }
            for (let index = 0; index < current_banner_mobile.length; index++) {
                fd.append(`current_banner_mobile[${index}]`, JSON.stringify(current_banner_mobile[index].objItem))
            }
            for (let index = 0; index < photo_product.length; index++) {
                fd.append(`name_photo_product[${index}]`, photo_product[index].name)
                fd.append(`file_photo_product[${index}]`, photo_product[index].file)
            }
            for (let index = 0; index < current_photo_product.length; index++) {
                fd.append(`current_photo_product[${index}]`, JSON.stringify(current_photo_product[index].objItem))
            }
            for (let index = 0; index < tarif_file.length; index++) {
                fd.append(`name_tarif_file[${index}]`, tarif_file[index].name)
                fd.append(`file_tarif_file[${index}]`, tarif_file[index].file)
            }
            for (let index = 0; index < current_tarif_file.length; index++) {
                fd.append(`current_tarif_file[${index}]`, JSON.stringify(current_tarif_file[index].objItem))
            }
            for (let index = 0; index < case_study.length; index++) {
                fd.append(`name_case_study[${index}]`, case_study[index].name)
                fd.append(`file_case_study[${index}]`, case_study[index].file)
            }
            for (let index = 0; index < current_case_study.length; index++) {
                fd.append(`current_case_study[${index}]`, JSON.stringify(current_case_study[index].objItem))
            }
            for (let index = 0; index < product_sharing.length; index++) {
                fd.append(`name_product_sharing[${index}]`, product_sharing[index].name)
                fd.append(`file_product_sharing[${index}]`, product_sharing[index].file)
            }
            for (let index = 0; index < current_product_sharing.length; index++) {
                fd.append(`current_product_sharing[${index}]`, JSON.stringify(current_product_sharing[index].objItem))
            }
            for (let index = 0; index < file_referensi.length; index++) {
                fd.append(`name_file_referensi[${index}]`, file_referensi[index].name)
                fd.append(`file_file_referensi[${index}]`, file_referensi[index].file)
            }
            for (let index = 0; index < current_file_referensi.length; index++) {
                fd.append(`current_file_referensi[${index}]`, JSON.stringify(current_file_referensi[index].objItem))
            }
            for (let index = 0; index < proposal_product.length; index++) {
                fd.append(`name_proposal_product[${index}]`, proposal_product[index].name)
                fd.append(`file_proposal_product[${index}]`, proposal_product[index].file)
            }
            for (let index = 0; index < current_proposal_product.length; index++) {
                fd.append(`current_proposal_product[${index}]`, JSON.stringify(current_proposal_product[index].objItem))
            }
          // typeof this.content.cfu == 'object' && this.content.cfu != null  && fd.append('CFU_ID', this.content.cfu.id)
          // typeof this.content.cfu_business_line == 'object' && this.content.cfu_business_line != null  && fd.append('CFU_BUSINESS_ID', this.content.cfu_business_line.id)
          // typeof this.content.cfu_product_line == 'object' && this.content.cfu_product_line != null  && fd.append('CFU_PRODUCT_ID', this.content.cfu_product_line.id)
            if (Array.isArray(this.content.cfu) && this.content.cfu.length > 0) {
                let ids = ''
                this.content.cfu.forEach(element => {
                    ids += element.id.toString() + ','
                });
                ids = ids.slice(0,-1)
                fd.append('CFU_ID', ids)
            }
            if (Array.isArray(this.content.cfu_business_line) && this.content.cfu_business_line.length > 0) {
                let ids = ''
                this.content.cfu_business_line.forEach(element => {
                    ids += element.id.toString() + ','
                });
                ids = ids.slice(0,-1)
                fd.append('CFU_BUSINESS_ID', ids)
            }
            if (Array.isArray(this.content.cfu_product_line) && this.content.cfu_product_line.length > 0) {
                let ids = ''
                this.content.cfu_product_line.forEach(element => {
                    ids += element.id.toString() + ','
                });
                ids = ids.slice(0,-1)
                fd.append('CFU_PRODUCT_ID', ids)
            }
            if (Array.isArray(this.content.division) && this.content.division.length > 0) {
                let ids = ''
                this.content.division.forEach(element => {
                    ids += element.id.toString() + ','
                });
                ids = ids.slice(0,-1)
                fd.append('DIVISION', ids)
            }
            if (this.prodSubCategory && (this.prodSubCategory.id || this.prodSubCategory.ID)) {
                fd.append('SUB_CATEGORY_TAGS', this.prodSubCategory.id ?? this.prodSubCategory.ID)
            }

          typeof this.content.parent == 'object' && this.content.parent != null  && fd.append('INHERIT_FROM', this.content.parent.KODE)
          typeof this.content.timePortfolio == 'object' && this.content.timePortfolio != null  && fd.append('TIME_PORTFOLIO_ID', this.content.timePortfolio.id)
          typeof this.content.partner == 'object' && this.content.partner != null  && fd.append('PARTNER_ID', this.content.partner.PROD_OWNER_ID)
          if (this.content.relatedProduct.length > 0) {
              let relatedProductIDsString = ''
              this.content.relatedProduct.forEach(element => {
                  relatedProductIDsString !== '' && (relatedProductIDsString += ',')
                  relatedProductIDsString += element.KODE
              });
              fd.append('relatedProduct', relatedProductIDsString)
          }
          if (this.content.contacts.length > 0) {
              this.content.contacts = this.content.contacts.filter(item => {
                  if (item.nama && item.email && item.phone) {
                      return true
                  } else {
                      return false
                  }
              })
              let contacts = this.content.contacts.map(item => {
                  let newItem = JSON.stringify(item)
                  return newItem
              })
              contacts.forEach(element => {
                  fd.append('contacts[]', element)
              });
          }
          if (this.content.faqs.length > 0) {
              this.content.faqs = this.content.faqs.filter(item => {
                  if (item.title && item.content) {
                      return true
                  } else {
                      return false
                  }
              })
              let faqs = this.content.faqs.map(item => {
                  let newItem = JSON.stringify(item)
                  return newItem
              })
              faqs.forEach(element => {
                  fd.append('faqs[]', element)
              });
          }
          return fd
        },
        getFiles() {
            return this.dropzone.getAcceptedFiles()
        },
        validationForm() {
            let errMessage = [];
            if(this.product == '' || this.product == null || this.product == '<br>'){
                errMessage.push('Product')
            }
            if(this.prodCategory == '' || this.prodCategory == null || this.prodCategory == '<br>'){
                errMessage.push('Portfolio')
            }
            if(this.content.timePortfolio == '' || this.content.timePortfolio == null || this.content.timePortfolio == '<br>'){
                errMessage.push('Time Portofolio')
            }
            if(this.content.cfu == '' || this.content.cfu == null || this.content.cfu == '<br>'){
                errMessage.push('CFU')
            }
            if(this.content.cfu_business_line == '' || this.content.cfu_business_line == null || this.content.cfu_business_line == '<br>'){
                errMessage.push('CFU Business Line')
            }
            if(this.content.cfu_product_line == '' || this.content.cfu_product_line == null || this.content.cfu_product_line == '<br>'){
                errMessage.push('CFU Product Line')
            }
            if(this.content.division == '' || this.content.division == null || this.content.division == '<br>'){
                errMessage.push('Division')
            }
            if(this.content.description == '' || this.content.description == null || this.content.description == '<br>'){
                errMessage.push('Description')
            }
            if(this.content.shortDescription == '' || this.content.shortDescription == null || this.content.shortDescription == '<br>'){
                errMessage.push('Short Description')
            }
            if(this.content.benefit == '' || this.content.benefit == null || this.content.benefit == '<br>'){
                errMessage.push('Benefit')
            }
            if(this.content.customerSTP == '' || this.content.customerSTP == null || this.content.customerSTP == '<br>'){
                errMessage.push('Customer STP')
            }
            if(this.content.configuration == '' || this.content.configuration == null || this.content.configuration == '<br>'){
                errMessage.push('Configuration')
            }
            if(this.content.slgsla == '' || this.content.slgsla == null || this.content.slgsla == '<br>'){
                errMessage.push('SLG/SLA')
            }
            if(this.content.faqs == '' || this.content.faqs == null || this.content.faqs == '<br>'){
                errMessage.push('Faqs')
            }
            if(this.content.division == '' || this.content.division == null || this.content.division == '<br>'){
                errMessage.push('Division')
            }
            if(this.dropzoneElements.file_referensi == '' || this.dropzoneElements.file_referensi == null){
                errMessage.push('File Reference')
            }

            if(errMessage.length > 0){
                this.$notif('Please fill these field',`${errMessage.join(', ')} fields is required.`,'danger','InfoIcon',5000)
                return false;
            }

            return this.$refs.simpleRules.validate()
        },
        save() {
            this.validationForm()
                .then(success => {
                    success && !this.isEdit && this.createProduct()
                    success &&  this.isEdit && this.updateProduct()
            })
        },
        resetFields() {
            this.product = ''
            this.prodCategory = ''
            this.content = this.freshContent
            this.prodSubCategory = ''
        },
        async getDivision(id) {
            return await this.$http.get(`/division/take/all/cfu/${id}`)
            .then(res => {
                this.options.divisions = res.data.data.records
                return res
            })
            .catch(err => {
                console.error(err)
            })
        },
        async getTimePorfolio() {
            return await this.$http.get(`/time-portfolio/take/all`)
            .then(res => {
                this.options.timePortfolios = res.data.data.records
            })
        },
        async getCFU() {
            return await this.$http.get(`/cfu/take/all`)
            .then(res => {
                this.options.cfus = res.data.data.records
            })
        },
        async getCFUBusinessLine(id) {
            return await this.$http.get(`/cfu-business-line/take/all/cfu/${id}`)
            .then(res => {
                this.options.cfusBusiness = res.data.data.records
                return res
            })
        },
        async getCFUProductLine(id) {
            return await this.$http.get(`/cfu-product-line/take/all/cfu-business/${id}`)
            .then(res => {
                this.options.cfusProduct = res.data.data.records
                return res
            })
        },
        async getProductDropdown() {
            return await this.$http.get(`/product/take/all/special.dropdown/true/except.this/${this.$route.params.key}`)
            .then(res => {
                this.options.productList = res.data.data.records
            })
        },
        async getPartner() {
            return await this.$http.get(`/partner`)
            .then(res => {
                this.options.partnerList = res.data.data
            })
        },
        onCfuChange(id) {
            this.getCFUBusinessLine(id)
            this.getDivision(id)
        },
        onCfuBusinessChange(id) {
            this.getCFUProductLine(id)
        },
        mappingFile(files, mapFile) {
            let result = mapFile.filter(x => files.includes(x.file))
            return result
        },
        mappingCurrentFile(files) {
            if (Array.isArray(files) && files.length > 0) {
                let result = files.map(x => {
                    let item = x.objItem ? x.objItem : x
                    return { objItem: item }
                })
                return result
            }
            return []
        },
        async approval() {
            return await this.$http.put(`/product/approval/${this.$route.params.key}`)
            .then(res => {
                this.$notif('Success', '', 'success')
                this.getProduct()
                this.$router.back()
            })
            .catch(err => {
                let message = ''
                if (typeof err.data.errors === 'object') {
                    message = err.data.errors[Object.keys(err.data.errors)[0]][0]
                } else if (typeof err.data.exception === 'object') {
                    message = err.data.exception.message
                }
                this.$notif('Something Error', message , 'danger')
            })
        },
        isFile: item => 'File' in window && item instanceof File,
        
    }
}
</script>

<style scoped>
.ql-container {
  height: 200px;
}
.dz-error-message {
    margin-top:30px;
}
.dropzone .dz-preview .dz-error-message {
    top: 150px!important;
}
.dropzone {
    min-height: 300px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style>
.dz-preview.dz-existing-hidden {
    display: none !important;
}
</style>
